<template>
    <div class="wos_by_pub_box">
        <el-carousel :height="height" :autoplay="true">
            <el-carousel-item v-for="(item, index) in wosOfPubList" :key="index">
                <div class="wos_by_pub_item" @click="goToPage(item.link)">
                    <div class="wos_by_pub_item_left">
                        <img :src="item.pubImg" alt="" class="left_img">
                    </div>
                    <!-- <div class="wos_by_pub_item_right">
                        <img :src="item.wosImg" alt="" class="right_img1">
                        <img :src="item.pubPlusImg" alt="" class="right_img2">
                    </div> -->
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import { wosOfPubList } from '../data';

export default {
    data() {
        return {
            wosOfPubList,
            height: "",
        }
    },
    methods: {
        goToPage(link) {
            window.open(link, '_blank')
        },
        updatePagerCount() {
            const width = window.innerWidth;
            this.height = width < 768 ? '200px' : '400px';
        },
    },
    mounted() {
        this.updatePagerCount();
        window.addEventListener('resize', this.updatePagerCount);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updatePagerCount);
    },
}
</script>

<style lang='scss'>
@import "../../../assets/css/minix.scss";

.wos_by_pub_box {
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    background-color: white;

    img {
        width: 100%;
    }

    .wos_by_pub_item {
        // display: flex;

        &:hover {
            cursor: pointer;
        }

        .wos_by_pub_item_left {
            .left_link {
                margin-bottom: 20px;
            }
        }

        .wos_by_pub_item_right {
            display: flex;
            flex-direction: column;
            align-items: end;

            .right_img1 {
                width: 270px;
            }

            .right_img2 {
                margin-top: 20px;
                margin-right: 30px;
                width: 190px;
            }
        }
    }
}

@media (max-width: 768px) {
    .wos_by_pub_box {
        .wos_by_pub_item {
            height: 100%;

            .wos_by_pub_item_left {
                img {
                    object-fit: cover;
                    height: 100%;
                }
            }

            .wos_by_pub_item_right {
                display: none;
            }
        }
    }
}
</style>